webpackJsonp([3],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	module.exports = __webpack_require__(22);


/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	/*
	var $ = require('jquery');
	var stats = require('./stats');
	
	$(function () {
	    var players = [];
	    $('option.popt', this.player_select).each(function(index, val) {
	        players[index] = val;
	    });
	    function jump_menu(){
	        this.el = $('#jump-menu');
	        this.team_select = this.el.find('select[name=team]');
	        this.player_select = this.el.find('select[name=player]');
	
	        this.team_select.change($.proxy(this.change_team, this));
	        this.player_select.change($.proxy(this.change_player, this));
	        return this;
	    }
	
	    jump_menu.prototype.toggle_players = function(){
	        if(this.team_select.val().length){
	            var team = this.team_select.val();
	            // hide all players
	            this.player_select.find('.popt').remove();
	            //show elements
	            var player_select = this.player_select;
	            $(players).each(function(index, val) {
	                if($(this).data('team') == team) {
	                    player_select.append($(this));
	                }
	            });
	        }
	        else {
	            //show elements
	            var that = this;
	            $(players).each(function(index, val) {
	                that.player_select.append($(this));
	            });
	        }
	    };
	
	    jump_menu.prototype.change_team = function(){
	        // update players dropdown
	        this.toggle_players();
	
	        // reset player select
	        this.player_select.val('');
	    };
	
	    jump_menu.prototype.change_player= function(e){
	        window.location = $(e.currentTarget).val() + '#page';
	    };
	
	    new jump_menu().toggle_players();
	
	    $('#filters [name=season]').change(function () {
	        $('input[name="sort"]').val($('#filters [name=season]').val());
	        $('#pm-form').submit();
	    });
	});
	*/


/***/ })

});


// WEBPACK FOOTER //
// stats/player_base.83483a61b806fcf29434.js